import { addressSchema } from '@/components/address-form/schema'
import { z } from 'zod'

export const companyFormSchema = z.object({
  tax_id: z.string().optional(),
  corporate_name: z.string().min(1, 'Obrigatório'),
  address: addressSchema.extend({
    complement: z.string().optional(),
  }),
})

export type CompanyFormData = z.infer<typeof companyFormSchema>
